// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"552":"css/pdf","703":"css/admin"}[chunkId] + ".css";
};